import * as React from 'react';
import { Row, Image, Col } from '@thd-olt-component-react/core-ui';
import { getImageURL } from '../../common/utils/cardUtils';
import './WelcomeCardHeader.scss';

export const WelcomeCardHeader = () => {
  const year = new Date().getFullYear();

  return (
    <Row>
      <div className="WelcomeCardHeader__title">
        <Image
          width="111px"
          height="26px"
          src={getImageURL('LogoB2XReversed-min.svg')}
          alt="LogoB2XReversed-min"
        />&nbsp;
        <span className="WelcomeCardHeader__year">{year}</span>
      </div>
    </Row>
  );
};
